/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Shortcuts_HintInputs */

const cs_calendar_shortcuts_hint = /** @type {(inputs: Calendar_Shortcuts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← → posun · T dnes · D/W/M pohledy · N nový · A agenda · / hledat`)
};

const en_calendar_shortcuts_hint = /** @type {(inputs: Calendar_Shortcuts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← → navigate · T today · D/W/M views · N new · A agenda · / search`)
};

/**
* | output |
* | --- |
* | "← → navigate · T today · D/W/M views · N new · A agenda · / search" |
*
* @param {Calendar_Shortcuts_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_shortcuts_hint = /** @type {((inputs?: Calendar_Shortcuts_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Shortcuts_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_shortcuts_hint(inputs)
	return cs_calendar_shortcuts_hint(inputs)
});